import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { spring, StaggeredMotion } from 'react-motion';

import ShowcaseCollectionCard from 'components/ShowcaseCollection/ShowcaseCollectionCard';

import { baseAppId } from 'settings';

export default class ShowcaseCollection extends Component {
  constructor(props) {
    super(props);

    this.timer = null;
    this.state = {
      showcaseCollection: [],
    };
  }

  componentDidMount() {
    this.init();
  }

  shouldComponentUpdate(nextProps, nextState) {
    // Only re-render if props or state actually changed
    const { stands, language } = this.props;
    const { showcaseCollection, startingValues, language: stateLanguage } = this.state;
    
    return (
      nextProps.stands !== stands ||
      nextProps.language !== language ||
      nextState.showcaseCollection !== showcaseCollection ||
      nextState.startingValues !== startingValues ||
      nextState.language !== stateLanguage
    );
  }

  componentDidUpdate(prevProps) {
    // Re-initialize if props changed
    const { stands, language } = this.props;
    if (prevProps.stands !== stands || prevProps.language !== language) {
      this.init();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  init() {
    const { language, stands: showcaseCollection } = this.props;

    // Ensure showcaseCollection is an array
    const collectionArray = Array.isArray(showcaseCollection) ? showcaseCollection : [];

    const startingValues = collectionArray.map(() => ({
      data: 0,
      pos: 20,
    }));

    this.setState({ 
      showcaseCollection: collectionArray,
      startingValues,
      language 
    });
  }

  renderStaggeredMotion() {
    const { showcaseCollection, startingValues, language } = this.state;

    // Don't render if no data
    if (!showcaseCollection || showcaseCollection.length === 0) {
      return null;
    }

    return (
          <React.Fragment>
            {showcaseCollection.map((showcase, i) => {
              if (!showcase) {
                return null;
              }
              
              const { propertyName, headerImages, type, id, description } = showcase;
 
              
              if (!propertyName) {
                return null;
              }

              return (
                <React.Fragment key={id}>
                  <div key={id} className="ShowcaseCollectionCard__Animated">
                    <ShowcaseCollectionCard
                      appId={baseAppId}
                      key={id}
                      index={i}
                      image={headerImages && headerImages[0]}
                      subtitle={description}
                      title={propertyName}
                      type={type}
                      itemID={id}
                      language={language}
                    />
                  </div>
                </React.Fragment>
              );
            })}
          </React.Fragment>
    );      
  }

  render() {
    return (
      <div className="showcaseCollection__Grid">
        {this.renderStaggeredMotion()}
        <style>{'\
        .fancybox-slide--iframe .fancybox-content { max-width  : 960px; margin: 0; } '}</style>
      </div>
    );
  }
}

ShowcaseCollection.propTypes = {
  language: PropTypes.string,
  stands: PropTypes.arrayOf(
    PropTypes.shape({
      address: PropTypes.string,
      category: PropTypes.string,
      city: PropTypes.string,
      contactEmail: PropTypes.string,
      coords: PropTypes.shape({
        latitude: PropTypes.number,
        longitude: PropTypes.number,
      }),
      country: PropTypes.string,
      description: PropTypes.string,
      headerImages: PropTypes.arrayOf(PropTypes.string),
      hide_address: PropTypes.string,
      icon: PropTypes.string,
      id: PropTypes.string,
      image: PropTypes.string,
      live: PropTypes.string,
      offer: PropTypes.string,
      phoneNumber: PropTypes.string,
      propertyName: PropTypes.string,
      region: PropTypes.string,
      // show: PropTypes,
      subCat: PropTypes.string,
      summary: PropTypes.string,
      userInfoID: PropTypes.string,
    }),
  ).isRequired,
};

ShowcaseCollection.defaultProps = {
  language: 'en',
};
